import type { ColDef, ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'
import type { Menu } from '~/components/ActionMenu'
import type { IReviewTopic } from '~/types/review'

import ActionMenu from '~/components/ActionMenu'
import ApplicationsListCellRenderer from '~/components/CellRenderers/ApplicationsListCellRenderer'
import TextCellRenderer from '~/components/CellRenderers/TextCellRenderer'
import { actionsColDef, applicationsListColDef, textColDef } from '~/utils/table'

export interface IContext {
  handleDelete: (isOpen: boolean, topic?: IReviewTopic) => () => void
  handleEdit: (isOpen: boolean, topic?: IReviewTopic) => () => void
  reviewsWriteAuthorized: boolean
}

const ActionsCellRenderer = ({ context, data }: ICellRendererParams<IReviewTopic, unknown, IContext>): ReactElement => {
  const { handleDelete, handleEdit, reviewsWriteAuthorized } = context

  if (data) {
    const menu: Menu = {
      actions: [
        {
          action: handleEdit(true, data),
          label: 'Edit',
          type: 'default',
        },
        {
          action: handleDelete(true, data),
          label: 'Delete',
          type: 'default',
        },
      ],
    }
    return <ActionMenu disabled={!reviewsWriteAuthorized} menu={menu} placement="top" />
  }

  return <div />
}

const columns: ColDef<IReviewTopic>[] = [
  applicationsListColDef(ApplicationsListCellRenderer, {
    field: 'applications',
  }),
  textColDef(TextCellRenderer, {
    field: 'category',
    headerName: 'Category',
    tooltipField: undefined,
  }),
  textColDef(TextCellRenderer, {
    field: 'label',
    headerName: 'Label',
    tooltipField: undefined,
  }),
  textColDef(TextCellRenderer, {
    field: 'description',
    headerName: 'Description',
    suppressSizeToFit: true,
    tooltipField: undefined,
    width: 400,
  }),
  actionsColDef(ActionsCellRenderer, {
    field: 'actions',
  }),
]

export default columns
